import { UntypedFormControl } from '@angular/forms';
import { DropdownConfiguration } from '@zipari/shared-ds-util-form';

export const syncHiddenControl = (
  config: DropdownConfiguration,
  value: string | string[],
) => (config.valueAsArray && value && !Array.isArray(value) ? [value] : value);

export const getUpdatedControlValue = (
  config: DropdownConfiguration,
  control: UntypedFormControl,
) => {
  const { defaultValue, options } = config;

  return control.value
    ? Array.isArray(control.value)
      ? control.value[0]
      : control.value
    : defaultValue === 'true' && options?.length > 0
      ? options[0].value
      : defaultValue?.length > 0
        ? defaultValue
        : undefined;
};
